import React from "react"; 
import { AppRouteProps } from "@bsm/component";
const AdmissionListContainer = React.lazy(() => import('./container/AdmissionListContainer'));

export const AdmissionListRoutes: Array<AppRouteProps> = [
    {
        path: '',
        element: <AdmissionListContainer />,
        children: []
    }
]